const RoutingOverviewIcon = ({ id, className = {} }) => {
    return (
        <svg id={id} className={className} viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
            <path d="M55 16.5H33L27.5 11H11C7.975 11 5.5275 13.475 5.5275 16.5L5.5 49.5C5.5 52.525 7.975 55 11 55H55C58.025 55 60.5 52.525 60.5 49.5V22C60.5 18.975 58.025 16.5 55 16.5ZM38.5 44H16.5V38.5H38.5V44ZM49.5 33H16.5V27.5H49.5V33Z" />
        </svg>
    );
};

export default RoutingOverviewIcon;
